import React, { useState } from 'react';
import Nav from './Nav';

export default function UpgradePage({ token, onNavigate, onLogout, userRole, currentPage }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpgrade = async () => {
    if (!token) { onNavigate('login'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Failed to start checkout.'); setLoading(false); return; }
      window.location.href = data.url;
    } catch {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Nav onNavigate={onNavigate} onLogout={onLogout} userRole={userRole} currentPage={currentPage} />

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold mb-3" style={{ color: '#1B3A5C' }}>Choose Your Plan</h1>
          <p className="text-gray-500 text-lg">Equip your ministry with the right tools</p>
        </div>

        {/* Comparison cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl">

          {/* Free */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm flex flex-col">
            <div className="mb-6">
              <span className="inline-block bg-gray-100 text-gray-600 text-xs font-semibold px-3 py-1 rounded-full mb-3">FREE</span>
              <h2 className="text-2xl font-bold text-gray-800">Free</h2>
              <p className="text-4xl font-bold text-gray-800 mt-2">$0<span className="text-lg text-gray-400 font-normal">/month</span></p>
            </div>
            <ul className="space-y-3 flex-1 mb-8">
              {[
                '5 generations per month',
                'All 10 ministry tools',
                'Sermon builder, devotionals, prayer guides',
                'History saved',
                'No credit card required',
              ].map(f => (
                <li key={f} className="flex items-start gap-2 text-sm text-gray-600">
                  <span className="text-gray-400 mt-0.5">✓</span>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <div className="py-3 rounded-xl text-center text-sm text-gray-400 border border-gray-200 font-medium">
              Your current plan
            </div>
          </div>

          {/* Pastor Pro */}
          <div className="bg-white rounded-2xl p-8 shadow-lg flex flex-col relative" style={{ border: '2px solid #C8921A' }}>
            <div className="absolute -top-3 left-1/2 -translate-x-1/2">
              <span className="bg-yellow-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow">MOST POPULAR</span>
            </div>
            <div className="mb-6">
              <span className="inline-block text-xs font-semibold px-3 py-1 rounded-full mb-3" style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}>PASTOR PRO</span>
              <h2 className="text-2xl font-bold" style={{ color: '#1B3A5C' }}>Pastor Pro</h2>
              <p className="text-4xl font-bold mt-2" style={{ color: '#C8921A' }}>$15<span className="text-lg text-gray-400 font-normal">/month</span></p>
              <p className="text-xs text-gray-400 mt-1">Cancel anytime</p>
            </div>
            <ul className="space-y-3 flex-1 mb-8">
              {[
                { text: 'Unlimited generations', bold: true },
                { text: 'All 10 ministry tools' },
                { text: 'Sermon builder, devotionals, prayer guides' },
                { text: 'Full history saved' },
                { text: 'Priority support' },
              ].map(f => (
                <li key={f.text} className="flex items-start gap-2 text-sm">
                  <span className="mt-0.5" style={{ color: '#C8921A' }}>✓</span>
                  <span className={f.bold ? 'font-semibold text-gray-800' : 'text-gray-600'}>{f.text}</span>
                </li>
              ))}
            </ul>
            {error && <p className="text-red-500 text-sm text-center mb-3">{error}</p>}
            <button
              onClick={handleUpgrade}
              disabled={loading}
              className="w-full py-4 rounded-xl text-white font-bold text-base transition-opacity hover:opacity-90 disabled:opacity-60 shadow-md"
              style={{ backgroundColor: '#C8921A' }}
            >
              {loading ? 'Redirecting to Stripe...' : 'Upgrade to Pastor Pro →'}
            </button>
            <p className="text-xs text-center text-gray-400 mt-3">Secure checkout via Stripe. Cancel anytime.</p>
          </div>
        </div>

        <button
          onClick={() => onNavigate('dashboard')}
          className="mt-8 text-sm text-gray-400 hover:text-gray-600 transition-colors"
        >
          ← Back to Dashboard
        </button>
      </main>
    </div>
  );
}
